// router/index.js
import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router'

import Cart from '@/app/Checkout/views/Mobile/Cart/index.vue'
import Checkout from '@/app/Checkout/views/Mobile/Checkout/index.vue'
import AddressList from '@/app/Checkout/views/Mobile/AddressList/index.vue'
import AddressForm from '@/app/Checkout/views/Mobile/AddressForm/index.vue'

function getBase() {
  // extracts "/en-en/checkout/purchase/"
  const match = window.location.pathname.match(/^\/([^/]+)\/checkout\/purchase(?:\/|$)/)
  if (!match) return '/'
  return `/${match[1]}/checkout/purchase/`
}

const routes = [
  { path: '', component: Cart, name: 'Cart' },
  { path: '/checkout', component: Checkout, name: 'Checkout' },
  { path: '/addresses', component: AddressList, name: 'AddressList' },
  { path: '/addresses/new', component: AddressForm, name: 'AddAddress' },
  { path: '/addresses/:id/edit', component: AddressForm, name: 'EditAddress' },
]

const router = createRouter({
  history: createWebHistory(getBase()),
  routes,
})

/** Creates a router for the QuickCart overlay with memory history (isolated from main page URL) */
export function createOverlayRouter() {
  return createRouter({
    history: createMemoryHistory('/'),
    routes: [...routes],
  })
}

export default router
